<template>
    <div ref="container">
      <a-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 50%;">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字典名称" prop="dicName">
                  <a-input placeholder="请输入字典名称" v-model="form.dicName" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字典编码" prop="dicCode">
                  <a-input placeholder="请输入字典编码" v-model="form.dicCode" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上级字典">
                <a-select placeholder="请选择上一级字典" v-model="selectedId" style="width: 100%;" @change="handleChange($event)">
                  <a-select-option v-for="(item,index) in parants" :key="index" :value="item.id" :disabled="form.dicName && item.dicName === form.dicName">
                    {{ item.dicName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-spin>
      </a-modal>
    </div>
  </template>
  <script>
  import { dictList, dictionaryDataList, dictAdd, dictEdit } from '@/api/api'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
    },
    data() {
      return {
        title: '操作',
        visible: false,
        fileList: [],
        model: {},
        parantId: [],
        parants: [],
        isReadOnly: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        selectedId: null,
        confirmLoading: false,
        form: {
            dicName: '',
            dicCode: '',
            dicType: 'TRACE_GOODS_CATEGORY',
            parantId: '',
        },
        uploadHeaders: {},
        rules: {
            dicName: [{ required: true, message: '字典名称不可为空!' }],
            dicCode: [{ required: true, message: '字典编码不可为空!' }],
            parantId: [{ required: true, message: '字典id不能为空!' }],
        },
        id: '',
      }
    },
    created() {},
    methods: {
        async show(e){
            console.log(e,'传递的值==============')
            this.visible = true
            await this.getParentList()
            if( e ){
                this.form = e;
                console.log(this.parants,'this.parants====================')
                const selectedItem = this.parants.find(item => item.id  === e.parantId );
                if (selectedItem) {
                    this.selectedId = selectedItem.id;
                    // this.form.dicName = selectedItem.parantDicName;
                } else {
                    this.selectedId = null
                }
            } else {

            }
        },
      async getParentList() {
        const res = await dictionaryDataList({ type: 'TRACE_GOODS_CATEGORY' })
        if (res.code == 200 && res.success == true ) {
          this.parants = res.result
        }
      },
    //   选择父节点id
    handleChange(value){
        const selectedItem = this.parants.find(item => item.id === value);
      if (selectedItem) {
        this.form.parantId = selectedItem.id;
        this.form.parantDicName = selectedItem.dicName;
      }
    },
    close() {
        this.$emit('close')
        this.visible = false
        this.form = {}
    },
      handleOk() {
        const that = this
        // 触发表单验证
        that.$refs['form'].validate(async (success) => {
          if (success === true) {
            let params = {
                dicName: this.form.dicName || '',
                dicCode: this.form.dicCode || '',
                dicType: 'TRACE_GOODS_CATEGORY',
                parantId: this.form.parantId,
            }
            if (this.id) {
              // 编辑
              params.id = this.id
              const res = await dictEdit(params)
              if ( res.code == 200 && res.success == true ) {
                this.$message.success( res.result )
                this.close()
                // 清空form
                this.form = {}
              } else {
                this.$message.error(res.data || res.result)
              }
            } else {
              const res = await dictAdd(params)
              if ( res.code == 200 && res.success == true ) {
                this.$message.success( res.result )
                this.close()
                this.form = {}
              } else {
                this.$message.error(res.data || res.result)
              }
            }
          }
        })
      },
      handleCancel() {
        this.close()
      },
    },
  }
  </script>
  <style scoped>
  </style>